import {createWebHistory, createRouter} from 'vue-router'
import Aluminuim_dash from "@/components/aluminuim_dash.vue";
import Add_aluminium_profile from "@/components/Add_aluminium_profile.vue";
import Edit_alu_Profile from "./components/Edit_alumium_profile.vue"

const routes = [
    {
        name: 'Aluminium_dash',
        path: '/aluminium_dash',
        component: Aluminuim_dash
    },
    {
        name: 'Add_alu_Profile',
        path: '/add_aluminiu',
        component: Add_aluminium_profile
    },
    {
        name: 'Edit_alu_Profile',
        path: '/Edit_alu_Profile/:sr', // we are opening url based on 'sr' so this way we are sending our sr value
        component: Edit_alu_Profile,
        props: true
    },
]

const router = createRouter({
    history: createWebHistory(),
    routes
})

export default router;